var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataReady)?_c('div',{staticClass:"row gutter-sm q-mb-md"},_vm._l((_vm.statisticsComponents),function(component){return _c(_vm.registeredComponent(component),{key:component,tag:"component",staticClass:"col-md-4 col-sm-12 col-xs-12 q-pa-sm",attrs:{"hasRedirect":true}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }